export default __webpack_public_path__ + "static/media/449East18.ff7b515c.png";